import script from "./wechat-recharge-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./wechat-recharge-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./wechat-recharge-dialog.vue?vue&type=style&index=0&id=ea9ec074&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea9ec074"]])

export default __exports__